import { Resource, NamedResource } from "client/resources";
import Chip from "./Chip";
import * as React from "react";
import Avatar from "material-ui/Avatar";
import SvgTenantIcon from "material-ui/svg-icons/action/account-circle";
import SvgEnvironmentIcon from "material-ui/svg-icons/device/storage";
import SvgTeamIcon from "material-ui/svg-icons/social/group";
import SvgChannelIcon from "material-ui/svg-icons/communication/call-split";
import SvgRoleIcon from "material-ui/svg-icons/maps/local-offer";
import {
    ProjectResource,
    TenantResource,
    CertificateResource,
    MachineModelHealthStatusResource,
    CommunicationStyleResource,
} from "client/resources";
import { TeamResource } from "client/resources/teamResource";
import { ProjectGroupResource } from "client/resources/projectGroupResource";
import {
    success, danger, dangerHighlight, alert, disable, white, primaryLight, secondaryText,
    primaryDark, secondaryBackground
} from "colors";
import * as moment from "moment";
import SvgIconMaterial from "material-ui/SvgIcon";
import {primaryText} from "colors";
import {UserRoleResource} from "client/resources/userRoleResource";
import NamedReferenceItem from "client/resources/namedReferenceItem";
import {DocumentTypeResource, EventCategoryResource, EventGroupResource} from "client/resources/eventResource";
import {LookupResourceChipComponent} from "../LookupResourceChip/LookupResourceChip";

interface ExtraCommonProps {
    description?: string;
    backgroundColor?: string;
    markAsRemoved?: boolean;
    labelColor?: string;
    children?: any;
}

export interface CommonChipProps {
    tabIndex?: number;
    onRequestDelete?: (event: object) => void;
    fullWidth?: boolean;
}

interface IconStyles {
    margin: number;
    fill: string;
    width: number;
    height: number;
    backgroundColor?: string;
}

const iconStyles: IconStyles = {
    margin: 5,
    fill: primaryText,
    width: 14,
    height: 14
};

const avatarStyles = {
    width: 24,
    height: 24,
};

// We are using SVG content directly because SvgIconMaterial doesn't allow us to reference svg files directly.
// Do we even need to use material ui here? What about using a regular img tag?

const SvgExcludedEnvironmentIcon = (props: any) => <SvgIconMaterial {...props} viewBox="0 0 200 200">
    {/* tslint:disable-next-line */}
    <path d="M6.712773 20.366522l7.783858-8.205343 176.512813 167.445863-7.783858 8.205343zM189.39 165.21v-31.34h-33.02l33.02 31.34"/>
    {/* tslint:disable-next-line */}
    <path d="M139.94 133.87H18.13v34.58H176.4zM35 159.61v-16.88h17.3v16.88zM138.58 116.99h50.81V82.41h-87.27l36.46 34.58M85.7 82.41H18.13V117h104zM35 108.14V91.26h17.3v16.88zM84.33 65.53h105.06V30.95H47.88l36.45 34.58M52.3 50.72v5.96H35.01V39.8h5.77l-9.33-8.85H18.13v34.58h49.78L52.3 50.72"/>
</SvgIconMaterial>;

const SvgProjectIcon = (props: any) => <SvgIconMaterial {...props} viewBox="0 0 200 200">
    {/* tslint:disable-next-line */}
    <path d="M174.33 26H25.67A14.67 14.67 0 0 0 11 40.7v14.36h178V40.7A14.67 14.67 0 0 0 174.33 26zM11 63.09v96.21A14.72 14.72 0 0 0 25.67 174h148.66A14.72 14.72 0 0 0 189 159.3V63.09zm59.12 58.42h-37v-37h37zm93.63 17H87.11a4.06 4.06 0 1 1 0-8.11h76.64a4.06 4.06 0 1 1 0 8.11zM83 111.52a4.06 4.06 0 0 1 4.06-4.06h59.31a4.06 4.06 0 1 1 0 8.11H87.11a4.06 4.06 0 0 1-4.11-4.05zm81.61-18.83h-77.5a4.06 4.06 0 0 1 0-8.11h77.56a4.06 4.06 0 1 1 0 8.11z"/>
</SvgIconMaterial>;

const SvgMachineIcon = (props: any) => <SvgIconMaterial {...props} viewBox="0 0 200 200">
    {/* tslint:disable-next-line */}
    <path d="M170.17 16.15H29.83A3.83 3.83 0 0 0 26 20v116.71a3.83 3.83 0 0 0 3.83 3.83h65.34v15.73a14.94 14.94 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.67h43.9a14.93 14.93 0 0 0 28.27 0H158a4.83 4.83 0 1 0 0-9.67h-43.9a15 15 0 0 0-9.3-9.3v-15.74h65.34a3.83 3.83 0 0 0 3.83-3.83V20a3.83 3.83 0 0 0-3.8-3.85z"/>
</SvgIconMaterial>;

const SvgExcludedMachineIcon = (props: any) => {
    return <SvgIconMaterial {...props} viewBox="0 0 200 200"
                            style={{fill: white, margin: 5, height: 19.2, width: 19.2}}>
        {/* tslint:disable-next-line */}
        <path
            d="M174 20a3.83 3.83 0 0 0-3.83-3.83H42.09L174 126.63zM107.68 140.53h47.76l15.9 13.31 7.26-8.67L17.38 10.15l-7.26 8.67L26 32.12v104.59a3.83 3.83 0 0 0 3.83 3.83h65.34v15.73a14.94 14.94 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.67h43.9a14.93 14.93 0 0 0 28.27 0H158a4.83 4.83 0 1 0 0-9.67h-43.9a15 15 0 0 0-9.3-9.3v-15.74z"/>
    </SvgIconMaterial>;
};

const chipWithAvatar = (
        text: string,
        SvgIcon: any,
        props: CommonChipProps & ExtraCommonProps,
        customAvatar?: any,
        description?: string,
        labelColor?: string,
        customIconStyles?: IconStyles,
        fullWidth = false) => {
    return <Chip backgroundColor={secondaryBackground}
                 fullWidth={fullWidth}
                 labelColor={labelColor || primaryText}
                 description={description || text}
                 avatar={<Avatar style={customAvatar ? customAvatar : avatarStyles}
                                 size={24}
                                 icon={<SvgIcon style={customIconStyles || iconStyles}/>}/>}
          {...props}>
          {text}
    </Chip>;
};

export enum ChipIcon {
    Project,
    Machine,
    ExcludedMachine,
    Environment,
    ExcludedEnvironment,
    Role,
    Tenant,
    Channel,
    Team,
    Step,
    StepAction,
    ProjectGroup,
    CommunicationStyle,
    EventCategory,
    EventGroup,
    MachineModelHealthStatus,
    DocumentType,
}

// NOTE:
// This is used to show the user only what they can see, it may be filtered away by permissions
export function matchesToChips<T extends Resource>(set: T[], selected: string[], createChip: (x: T) => JSX.Element): JSX.Element[] {
    return set
        .filter(item => selected.indexOf(item.Id) !== -1)
        .map(item => createChip(item));
}

export function environmentChipList(set: NamedResource[], selectedIds: string[]) {
    return matchesToChips(set, selectedIds, x => <EnvironmentChip environmentName={x.Name} key={x.Id} />);
}

export function tenantChipList(set: TenantResource[], selectedIds: string[]) {
    return matchesToChips(set, selectedIds, x => <TenantChip tenant={x} key={x.Id} />);
}

export function projectChipList(set: ProjectResource[], selectedIds: string[]) {
    return matchesToChips(set, selectedIds, x => <ProjectChip project={x} key={x.Id} />);
}

export function documentChipList(set: DocumentTypeResource[], selectedIds: string[]) {
    return matchesToChips(set, selectedIds, x => <DocumentTypeChip documentType={x} key={x.Id} />);
}

export function eventCategoryList(set: EventCategoryResource[], selectedIds: string[]) {
    return matchesToChips(set, selectedIds, x => <EventCategoryChip eventCategory={x} key={x.Id} />);
}

export function eventGroupList(set: EventGroupResource[], selectedIds: string[]) {
    return matchesToChips(set, selectedIds, x => <EventGroupChip eventGroup={x} key={x.Id} />);
}

const MissingChip: React.StatelessComponent<{lookupId: string, type: ChipIcon} & CommonChipProps> = props => {

    const { lookupId, type, ...rest } = props;
    const text = "Missing Resource";

    // There are cases where this isn't right, but will just have 1 message to simplify
    // e.g. Variable Snapshots will show this for deleted environments, it's not an issue in that case, but good to show this.
    const description = `The ${ChipIcon[type]} document '${lookupId}' referenced by this record is no longer available or `
        + "you do not have permissions to see this resource. Please check with you Octopus Administrator regarding your "
        + "permissions. If you believe the resource is missing (and this is not permissions-related), please let Octopus "
        + "support know so that we can prevent this from happening in the future.";

    const customIconStyles: IconStyles = {
        ...iconStyles,
        fill: white,
        backgroundColor: danger
    };

    const chip = (svg: any) => chipWithAvatar(
        text,
        svg,
        {...rest, backgroundColor: dangerHighlight},
        {...avatarStyles, backgroundColor: danger},
        description,
        danger,
        customIconStyles);

    switch (type) {
        case ChipIcon.Project:
            return chip(SvgProjectIcon);
        case ChipIcon.Machine:
            return chip(SvgMachineIcon);
        case ChipIcon.ExcludedMachine:
            return chip(SvgExcludedMachineIcon);
        case ChipIcon.Environment:
            return chip(SvgEnvironmentIcon);
        case ChipIcon.ExcludedEnvironment:
            return chip(SvgExcludedEnvironmentIcon);
        case ChipIcon.Role:
            return chip(SvgRoleIcon);
        case ChipIcon.Tenant:
            return chip(SvgTenantIcon);
        case ChipIcon.Channel:
            return chip(SvgChannelIcon);
        case ChipIcon.Team:
            return chip(SvgTeamIcon);
        case ChipIcon.Step:
        case ChipIcon.StepAction:
        case ChipIcon.ProjectGroup:
        case ChipIcon.CommunicationStyle:
        case ChipIcon.EventCategory:
        case ChipIcon.EventGroup:
        case ChipIcon.MachineModelHealthStatus:
        case ChipIcon.DocumentType:
            return <Chip backgroundColor={dangerHighlight} labelColor={danger} description={description} {...rest}>{text}</Chip>;
        default:
            return <Chip backgroundColor={dangerHighlight} labelColor={danger} description={description} {...rest}>{text}</Chip>;
    }
};

const ProjectChip: React.StatelessComponent<{ project: ProjectResource; } & CommonChipProps> = props => {
    const { project, ...rest } = props;
    return chipWithAvatar(project.Name, SvgProjectIcon, { description: "Project: " + project.Name, ...rest });
};

const ProjectGroupChip: React.StatelessComponent<{ projectGroup: ProjectGroupResource; } & CommonChipProps> = props => {
    const { projectGroup, ...rest } = props;
    const description = "Project group: " + projectGroup.Name;
    return <Chip description={description} {...rest}>{projectGroup.Name}</Chip>;
};

const MachineModelHealthStatusChip: React.StatelessComponent<{
    healthStatus: MachineModelHealthStatusResource
} & CommonChipProps> = props => {
    const { healthStatus, ...rest } = props;
    const description = "Machine health: " + healthStatus.Name;
    return <Chip description={description} {...rest}>{healthStatus.Name}</Chip>;
};

const EndpointCommunicationStyleChip: React.StatelessComponent<{
    commStyle: CommunicationStyleResource;
} & CommonChipProps> = props => {
    const { commStyle, ...rest } = props;
    const description = "Communications style: " + commStyle.Name;
    return <Chip description={description} {...rest}>{commStyle.Name}</Chip>;
};

const EnvironmentChip: React.StatelessComponent<{
    environmentName: string;
    isExcluded?: boolean;
} & CommonChipProps> = props => {
    const {environmentName, isExcluded, ...rest} = props;
    return chipWithAvatar(environmentName, isExcluded ? SvgExcludedEnvironmentIcon : SvgEnvironmentIcon, {
        description: "Environment: " + environmentName,
        ...rest,
        markAsRemoved: isExcluded
    });
};

const MachineChip: React.StatelessComponent<{
    machineName: string;
    isExcluded?: boolean;
    isDisable?: boolean;
} & CommonChipProps> = props => {
    const {machineName, isExcluded, isDisable, ...rest} = props;
    return chipWithAvatar(machineName, (isExcluded || isDisable) ? SvgExcludedMachineIcon : SvgMachineIcon,
        {
            description: "Machine: " + machineName,
            ...rest,
            markAsRemoved: isExcluded,
            backgroundColor: isDisable ? disable : secondaryBackground,
            labelColor: isDisable ? danger : primaryText
        },
        isDisable ? {...avatarStyles, backgroundColor: danger} : avatarStyles);
};

const TenantChip: React.StatelessComponent<{ tenant: TenantResource } & CommonChipProps> = props => {
    const { tenant, ...rest } = props;
    return chipWithAvatar(tenant.Name, SvgTenantIcon, { description: "Tenant: " + tenant.Name, ...rest });
};

const TeamChip: React.StatelessComponent<{ team: TeamResource } & CommonChipProps> = props => {
    const { team, ...rest } = props;
    return chipWithAvatar(team.Name, SvgTeamIcon, { description: "Team: " + team.Name, ...rest});
};

const ChannelChip: React.StatelessComponent<{ channelName: string } & CommonChipProps> = props => {
    const { channelName, ...rest } = props;
    return chipWithAvatar(channelName, SvgChannelIcon, { description: "Channel: " + channelName, ...rest });
};

const RoleChip: React.StatelessComponent<{ role: string } & CommonChipProps> = props => {
    const { role, ...rest } = props;
    return chipWithAvatar(role, SvgRoleIcon, { description: "Role: " + role, ...rest });
};

const CertificateExpiryChip: React.StatelessComponent<{ certificate: CertificateResource } & CommonChipProps> = props => {
    const { certificate, ...rest } = props;
    const now = moment();
    const certificateExpiry = moment(certificate.NotAfter);
    const prefix = certificateExpiry.isAfter(now)
        ? "Expires "
        : "Expired ";
    const expiry = prefix + certificateExpiry.fromNow();
    let color = success;
    if (certificateExpiry.isBefore(now)) {
        color = danger;
    } else if (certificateExpiry.isBefore(now.add(20, "days"))) {
        color = alert;
    }
    const description = "Certificate expiry: " + expiry;
    return <Chip description={description} backgroundColor={"rgba(0,0,0,0)"} bordercolor={color} labelColor={color} {...rest}>{expiry}</Chip>;
};

const StepChip: React.StatelessComponent<{ stepName: string, suffix?: React.ReactNode } & CommonChipProps> = props => {
    const { stepName, suffix, ...rest } = props;
    const description = "Step: " + stepName;
    return <Chip description={description} {...rest}>{stepName}{suffix}</Chip>;
};

const UserRoleChip: React.StatelessComponent<{userRole: UserRoleResource} & CommonChipProps> = props => {
    const { userRole, ...rest } = props;
    const description = "User role: " + userRole.Name;
    return <Chip {...rest}>{userRole.Name}</Chip>;
};

const ExternalSecurityGroupChip: React.StatelessComponent<{group: NamedReferenceItem} & CommonChipProps> = props => {
    const { group, ...rest } = props;
    const text = group.DisplayIdAndName ? `${group.DisplayName} (${group.Id})` : group.DisplayName;
    return <Chip {...rest}>{text}</Chip>;
};

const ExternalSecurityGroupNameChip: React.StatelessComponent<{groupName: string} & CommonChipProps> = props => {
    const { groupName, ...rest } = props;
    return <Chip description={`Indirectly assigned via ${groupName}`} {...rest}>{groupName}</Chip>;
};

const FilterTextChip: React.StatelessComponent<{filterText: string} & CommonChipProps> = props => {
    const { filterText, ...rest } = props;
    return <Chip {...rest}>{filterText}</Chip>;
};

const EventCategoryChip: React.StatelessComponent<{eventCategory: EventCategoryResource} & CommonChipProps> = props => {
    const { eventCategory, ...rest } = props;
    const description = "Event category: " + eventCategory.Name;
    return <Chip description={description} {...rest}>{eventCategory.Name}</Chip>;
};

const EventCategoryPreviewChip: React.StatelessComponent<{eventCategory: EventCategoryResource} & CommonChipProps> = props => {
    const { eventCategory, ...rest } = props;
    const description = "Event category: " + eventCategory.Name;
    return <Chip description={description} {...rest} >{eventCategory.Name}</Chip>;
};

const DocumentTypeChip: React.StatelessComponent<{documentType: DocumentTypeResource} & CommonChipProps> = props => {
    const { documentType, ...rest } = props;
    const description = "Document type: " + documentType.Name;
    return <Chip description={description} {...rest}>{documentType.Name}</Chip>;
};

const EventGroupChip: React.StatelessComponent<{eventGroup: EventGroupResource} & CommonChipProps> = props => {
    const { eventGroup, ...rest } = props;
    const description = "Event group: " + eventGroup.Name;
    return <Chip description={description} {...rest}>{eventGroup.Name}</Chip>;
};

const DisabledChip: React.StatelessComponent<CommonChipProps> = props => {
    return <Chip {...props}
        bordercolor={secondaryText}
        labelColor={secondaryText}
        backgroundColor={"rgba(0,0,0,0)"}
    >Disabled</Chip>;
};

const DefaultOptionChip: React.StatelessComponent<CommonChipProps> = props => {
    return <Chip {...props}>Default</Chip>;
};

const LookupTenantChip: React.StatelessComponent<{lookupTenants: TenantResource[], id: string}> = props => {
    const TenantLookupChipInternal = LookupResourceChipComponent<TenantResource>();
    return <TenantLookupChipInternal
        lookupCollection={props.lookupTenants}
        key={props.id}
        lookupId={props.id}
        type={ChipIcon.Tenant}
        chipRender={item => <TenantChip tenant={item} />}/>;
};

export {
    MissingChip,
    ProjectChip,
    ProjectGroupChip,
    EnvironmentChip,
    RoleChip,
    TenantChip,
    TeamChip,
    ChannelChip,
    MachineChip,
    CertificateExpiryChip,
    MachineModelHealthStatusChip,
    EndpointCommunicationStyleChip,
    StepChip,
    UserRoleChip,
    ExternalSecurityGroupChip,
    ExternalSecurityGroupNameChip,
    FilterTextChip,
    EventCategoryChip,
    EventCategoryPreviewChip,
    DocumentTypeChip,
    EventGroupChip,
    DisabledChip,
    DefaultOptionChip,
    LookupTenantChip
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Chips/index.tsx